import React from 'react'
import PropTypes from 'prop-types'

import OptionPill from "./option-pill"
import OptionText from "./option-text"

// extends React.Component is required because of reference in parent
export default class SelectMultiGenericPopoverOption extends React.Component {

    static propTypes = {
        option          : PropTypes.object,

        isHighlighted   : PropTypes.bool,
        isSelected      : PropTypes.bool,

        onClick         : PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        const RenderComponent = !!this.props.option.color ? OptionPill : OptionText
        return <RenderComponent {...this.props} onClick={this.onClick}/>
    }
}